let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8vJte")).then(() => parcelRequire('3sw2b'));